import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'; // Import 'map' here
import { EncryptionService } from '../services/encryption.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
  constructor(private encryptionService: EncryptionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedRequest: HttpRequest<any>;
  
    // Check if the request body is FormData
    if (req.body instanceof FormData) {
      const originalFormData = req.body;
      const newFormData = new FormData();
  
      originalFormData.forEach((value, key) => {
        // Encrypt only specific fields in FormData
        if (['id', 'post_description', 'group_id', 'post_id', 'description', 'comment_id', 'search_value', 'message', 'email' ].includes(key)) {
          const encryptedValue = this.encryptionService.encryptData(value.toString());
          newFormData.append(key, encryptedValue);
        } else {
          newFormData.append(key, value);
        }
      });
  
      clonedRequest = req.clone({ body: newFormData });
  
    } else if (req.method === 'GET' && req.urlWithParams) {
      let updatedParams = new HttpParams();
    
      const url = new URL(req.urlWithParams, 'http://dummy-base-url'); // Required for parsing
      url.searchParams.forEach((value, key) => {
        if (['search_value', 'industry_id'].includes(key)) {
          const encryptedValue = this.encryptionService.encryptData(value);
    
          // Prevent double encoding by decoding once first
          const decodedEncryptedValue = decodeURIComponent(encryptedValue);
    
          // Set the param as raw (it will still get URL-encoded properly)
          updatedParams = updatedParams.set(key, decodedEncryptedValue);
        } else {
          updatedParams = updatedParams.set(key, value);
        }
      });
    
      const baseUrl = req.url.split('?')[0];
    
      clonedRequest = req.clone({
        url: baseUrl,
        params: updatedParams,
      });
    }
     else {
      const originalBody = req.body;
  
      // Check if originalBody contains a 'data' array
      if (originalBody && Array.isArray(originalBody.data)) {
        const encryptedData = originalBody.data.map((item: any) => {
          const encryptedItem = { ...item };
  
          // Encrypt only 'id' and 'title'
          ['id', 'title', 'type', 'email'].forEach((key) => {
            if (item[key] !== undefined && item[key] !== null) {
              encryptedItem[key] = this.encryptionService.encryptData(item[key].toString());
            }
          });
  
          return encryptedItem;
        });
  
        // Replace original 'data' with encrypted one
        const newBody = { ...originalBody, data: encryptedData };
        clonedRequest = req.clone({ body: newBody });
  
      } else {
        // Encrypt full body if not FormData or special 'data' array
        const encryptedBody = originalBody
          ? this.encryptionService.encryptData(JSON.stringify(originalBody))
          : null;
  
        clonedRequest = req.clone({
          body: encryptedBody ? { payload: encryptedBody } : undefined,
        });
  
        //console.log(' Encrypted JSON payload:', encryptedBody);
      }
    }
  
    return next.handle(clonedRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          try {
            const decryptedText = this.encryptionService.decryptData(event.body);
            const parsedData = JSON.parse(decryptedText);
            return event.clone({ body: parsedData });
          } catch (err) {
            console.error('Decryption failed:', err);
            return event;
          }
        }
        return event;
      })
    );
  }
  
  
}
